import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OnlineCart = () => {
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [totals, setTotals] = useState({ subtotal: 0, taxBreakdown: {}, total: 0 });

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);
    fetchTaxes();
    calculateTotals(storedCart);
  }, []);

const fetchTaxes = async () => {
  try {
    const cliente_id = localStorage.getItem("cliente_id");
    const response = await fetch(`/api/taxes?cliente_id=${cliente_id}`);
    const data = await response.json();
    console.log("📊 Impuestos obtenidos desde API:", data);  // Verificar resultado
    setTaxes(data || []);
  } catch (error) {
    console.error("Error al obtener los taxes:", error);
  }
};


const calculateTotals = (cartItems) => {
  let subtotal = 0;
  let taxBreakdown = {};

  cartItems.forEach((item) => {
    const modifiersTotal = item.selectedModifiers
      ? Object.values(item.selectedModifiers).flat().reduce((sum, mod) => sum + (mod.price || 0), 0)
      : 0;

    const itemSubtotal = (item.price || 0) + modifiersTotal;
    subtotal += itemSubtotal;

    if (item.taxDetails && item.taxDetails.length) {
      item.taxDetails.forEach((taxRate) => {
        const taxAmount = taxRate.amount;

        if (!taxBreakdown[taxRate.id]) {
          taxBreakdown[taxRate.id] = {
            name: taxRate.name,
            amount: 0,
          };
        }
        taxBreakdown[taxRate.id].amount += taxAmount;
      });
    }
  });

  const totalTax = Object.values(taxBreakdown).reduce((acc, tax) => acc + tax.amount, 0);
  const total = subtotal + totalTax;

  setTotals({
    subtotal: subtotal || 0,
    taxBreakdown,
    total: total || 0,
  });
};

  const removeFromCart = (index) => {
    const updatedCart = [...cart];
    updatedCart.splice(index, 1);
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    calculateTotals(updatedCart);
  };

const handleCheckout = async () => {
  try {
    const cliente_id = localStorage.getItem("cliente_id");

    if (!cliente_id) {
      alert("❌ Error: No se encontró el cliente_id.");
      return;
    }

    const orderItems = cart
      .filter(item => item.id)
      .map(item => ({
        product_id: item.id,
        name: item.name || "Producto sin nombre",
        price: Math.round(item.price * 100),
        quantity: item.quantity || 1,
        taxes: item.taxDetails?.length ? item.taxDetails : [], // ✅ Solo si existen
        modifiers: item.selectedModifiers 
          ? Object.values(item.selectedModifiers).flat() 
          : []  // ✅ Solo si existen
      }));

    if (orderItems.length === 0) {
      alert("❌ Error: No hay productos válidos en el carrito.");
      return;
    }

    // 🔥 REGISTRA LOS ITEMS QUE SE VAN A ENVIAR AL BACKEND
    console.log("🛒 Items en el carrito antes de enviar:", JSON.stringify(orderItems, null, 2));

    const response = await fetch('/api/orders', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        cliente_id,
        order_type: 'pickup',
        items: orderItems,
        email: 'cliente@example.com',
        first_name: 'John',
        last_name: 'Doe',
        phone_number: '123456789',
      }),
    });

    let data;
    try {
      data = await response.json();
    } catch (error) {
      console.error("❌ Error al parsear JSON de la respuesta:", error);
      alert("Error inesperado en la respuesta del servidor.");
      return;
    }

    if (response.ok) {
      console.log("✅ Checkout URL:", data.checkout_url);

      if (window.innerWidth <= 768) {  
        window.location.href = data.checkout_url;
      } else {  
        const newTab = window.open(data.checkout_url, "_blank");
        if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
          console.warn("⚠️ Popup bloqueado, redirigiendo...");
          window.location.href = data.checkout_url;  
        }
      }
    } else {
      console.error("❌ Error al crear la orden:", data.error);
      alert(`Error al crear la orden: ${data.error}`);
    }
  } catch (error) {
    console.error("❌ Error interno:", error);
    alert(`Error interno: ${error}`);
  }
};

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Carrito de Compras</h2>

      {cart.length === 0 ? (
        <p>El carrito está vacío</p>
      ) : (
        <div>
{cart.map((item, index) => {
  const modifiersTotal = item.selectedModifiers
    ? Object.values(item.selectedModifiers).flat().reduce((sum, mod) => sum + (mod.price || 0), 0)
    : 0;

  return (
    <div key={index} className="border p-2 mb-3">
      <div>
        <h4 className="font-semibold">{item.name}</h4>
        {item.description && <p className="text-gray-600">{item.description}</p>}
        <p>Precio Base: ${item.price.toFixed(2)}</p>

        {/* Mostrar impuestos asociados al producto */}
        {item.taxDetails?.map((tax) => (
          <p key={tax.id}>{tax.name}: ${tax.amount.toFixed(2)}</p>
        ))}

        {/* Mostrar Modificadores */}
        {item.selectedModifiers && Object.values(item.selectedModifiers).flat().length > 0 && (
          <div className="mt-2">
            <h5 className="font-semibold">Modificadores:</h5>
            <ul>
              {Object.values(item.selectedModifiers).flat().map((mod, modIndex) => (
                <li key={modIndex}>
                  {mod.name} - ${mod.price.toFixed(2)}
                </li>
              ))}
            </ul>
          </div>
        )}

        <p>Precio Final del Producto: ${(item.price + modifiersTotal).toFixed(2)}</p>
      </div>
      <button
        className="bg-red-500 text-white px-3 py-1 rounded mt-2"
        onClick={() => removeFromCart(index)}
      >
        Eliminar
      </button>
    </div>
  );
})}

          {/* Mostrar Totales */}
          <div className="mt-4 p-4 border-t border-gray-300">
            <h3 className="text-xl font-bold">Resumen del Pedido</h3>
            <p>Subtotal: ${totals.subtotal.toFixed(2)}</p>
            {Object.entries(totals.taxBreakdown).map(([taxId, tax]) => (
              <p key={taxId}>{tax.name}: ${tax.amount.toFixed(2)}</p>
            ))}
            <p className="font-bold">Total a Pagar: ${totals.total.toFixed(2)}</p>
          </div>

          <button className="btn btn-secondary mt-4" onClick={() => navigate("/ordenar-en-linea")}>
            Seguir Comprando
          </button>
<button className="btn btn-primary mt-4 w-full" onClick={handleCheckout}>
  Ir a Pagar
</button>

        </div>
      )}
    </div>
  );
};

export default OnlineCart;
